<template>
    <a class="inline-flex gap-0.5 justify-center overflow-hidden text-sm font-medium transition text-blue-500 hover:text-blue-600 dark:text-blue-400 dark:hover:text-blue-500 items-center"
        :href="href" target="_blank" :title="title">
        {{ title }}
        <Icon v-if="!no_icon" :name="icon || 'mdi:arrow-right-thin'" class="mt-0.5 h-5 w-5 relative top-px -mr-1" />
    </a>
</template>

<script lang="ts">
export default {
    props: {
        title: String,
        href: String,
        icon: String,
        no_icon: Boolean,
    },
};
</script>